export type Plan = 'free' | 'enterprise' | 'custom'

export const planRank: Record<Plan, number> = {
  free: 0,
  enterprise: 1,
  custom: 2,
}

export function isPlanAllowed(required: Plan, actual: Plan): boolean {
  return planRank[actual] >= planRank[required]
}

export function getPlanLabel(plan: Plan): string {
  if (plan === 'free') return '免费版'
  if (plan === 'enterprise') return '企业版'
  return '定制版'
}